module.exports = __webpack_public_path__ + "img/18.3ac6dde3.png";